const processName = (name) => { // 카테고리명 혹은 파일명 전처리 (확장자 제외 및 한글 자모 분리 현상 방지)
    if (!name) return '';

    const lastDotIndex = name.lastIndexOf('.');
    const nameWithoutExtension = lastDotIndex !== -1 ? name.substring(0, lastDotIndex) : name;
    
    return nameWithoutExtension.normalize('NFC');
};

export default processName;
